module.exports = __webpack_public_path__ + "static/img/sbktext1.1761547470324.png";